import { defineStore } from 'pinia';
import { ref } from 'vue';
import { FormInstance } from 'element-plus';
import { DocumentListFilterFormData } from '@/models/documents/document-list-filter.model';
import { DEFAULT_DOCUMENT_LIST_FILTER_FORM_DATA } from '@/constants/documents/document-list-filter.constant';
import { sanitizeDecimalInput } from '@/utils/sanitize-decimal-input.util';
import { tagListToTagIdList } from '@/mappers/dictionary/tag-list-to-tag-id-list.mapper';
import { segmentListToSegmentIdList } from '@/mappers/dictionary/segment-list-to-segment-id-list.mapper';

interface DocumentListFilterState {
  documentListFilterFormData: DocumentListFilterFormData;
}

export const documentListFilterFormRef = ref<FormInstance>();

export const useDocumentListFilterStore = defineStore('DocumentListFilterStore', {
  state: (): DocumentListFilterState => ({
    documentListFilterFormData: structuredClone(DEFAULT_DOCUMENT_LIST_FILTER_FORM_DATA),
  }),
  getters: {
    isFilterTagIdListNotEmpty(state: DocumentListFilterState): boolean {
      return state.documentListFilterFormData.tagList.length > 0;
    },
    isFilterSegmentIdListNotEmpty(state: DocumentListFilterState): boolean {
      return state.documentListFilterFormData.segmentList.length > 0;
    },
    filterTagIdList(state: DocumentListFilterState): string[] {
      return tagListToTagIdList(state.documentListFilterFormData.tagList);
    },
    filterSegmentIdList(state: DocumentListFilterState): string[] {
      return segmentListToSegmentIdList(state.documentListFilterFormData.segmentList);
    },
    isFilterCountryListNotEmpty(state: DocumentListFilterState): boolean {
      return state.documentListFilterFormData.countryList.length > 0;
    },
  },
  actions: {
    setTagIdListCondition(value: string): void {
      this.documentListFilterFormData.tagIdListCondition = value;
    },
    setSegmentIdListCondition(value: string): void {
      this.documentListFilterFormData.segmentIdListCondition = value;
    },
    setCountryListCondition(value: string): void {
      this.documentListFilterFormData.countryListCondition = value;
    },
    setMinTotalAmountEur(value: string | null): void {
      this.documentListFilterFormData.minTotalAmountEur = sanitizeDecimalInput(value ?? '');
    },
    setMaxTotalAmountEur(value: string | null): void {
      this.documentListFilterFormData.maxTotalAmountEur = sanitizeDecimalInput(value ?? '');
    },
  },
});
